import { useCheckIfValueExistsInDisplayOptions } from './useCheckIfValueExistsInDisplayOptions';
import type { ConfigDisplayOptions } from '@az/middleware/src/__generated__/gql/graphql';

interface IComponentNamesData {
  standard: string;
  [key: string]: string;
}

export const useGetComponentName = (data: IComponentNamesData, displayOptions: ConfigDisplayOptions[]) => {
  let componentName;
  for (const key of Object.keys(data)) {
    if (componentName) break;
    if (useCheckIfValueExistsInDisplayOptions(key, displayOptions)) {
      componentName = data[key];
    }
  }
  return componentName ? componentName : data.standard;
};
